import React from "react";

import img4 from "../Images/Galeria/4.png";
import img5 from "../Images/Galeria/5.png";
import img6 from "../Images/Galeria/6.png";
import img7 from "../Images/Galeria/7.png";
import img8 from "../Images/Galeria/8.png";
import img9 from "../Images/Galeria/9.png";
import img10 from "../Images/Galeria/10.png";
import img11 from "../Images/Galeria/11.png";
import img12 from "../Images/Galeria/12.png";
import img13 from "../Images/Galeria/13.png";
import img14 from "../Images/Galeria/14.png";
import img15 from "../Images/Galeria/15.png";
import img16 from "../Images/Galeria/16.png";
import img17 from "../Images/Galeria/17.png";
import img18 from "../Images/Galeria/18.png";
import img19 from "../Images/Galeria/19.png";
import img20 from "../Images/Galeria/20.png";
import img21 from "../Images/Galeria/21.png";
import img22 from "../Images/Galeria/22.png";
import img23 from "../Images/Galeria/23.png";
import img24 from "../Images/Galeria/24.png";
import img25 from "../Images/Galeria/25.png";
import img26 from "../Images/Galeria/26.png";
import img27 from "../Images/Galeria/27.png";
import img28 from "../Images/Galeria/28.png";
import img29 from "../Images/Galeria/29.png";
import img30 from "../Images/Galeria/30.png";
import img31 from "../Images/Galeria/31.png";

const InfiniteCarrusel = () => {
  const imagenes = [
    {
      img: img4,
    },
    {
      img: img5,
    },
    {
      img: img6,
    },
    {
      img: img7,
    },
    {
      img: img8,
    },
    {
      img: img9,
    },
    {
      img: img10,
    },
    {
      img: img11,
    },
    {
      img: img12,
    },
    {
      img: img13,
    },
    {
      img: img14,
    },
    {
      img: img15,
    },
    {
      img: img16,
    },
    {
      img: img17,
    },
    {
      img: img18,
    },
    {
      img: img19,
    },
    {
      img: img20,
    },
    {
      img: img21,
    },
    {
      img: img22,
    },
    {
      img: img23,
    },
    {
      img: img24,
    },
    {
      img: img25,
    },
    {
      img: img26,
    },
    {
      img: img27,
    },
    {
      img: img28,
    },
    {
      img: img29,
    },
    {
      img: img30,
    },
    {
      img: img31,
    },
  ];

  return (
    <div id="infinite" class="highway-slider">
      <div class="highway-barrier">
        <ul class="highway-lane">
          {imagenes.map((imagen) => (
            <li class="highway-car">
              <img
                alt=""
                style={{ width: "100%", borderRadius: "10px" }}
                src={imagen.img}
              />
            </li>
          ))}
          {/* <li class="highway-car">
            <img
              alt=""
              style={{ width: "100%", borderRadius: "15px" }}
              src={carrusel1}
            ></img>
          </li>
          <li class="highway-car">
            <img
              alt=""
              style={{ width: "100%", borderRadius: "15px" }}
              src={carrusel2}
            ></img>
          </li>
          <li class="highway-car">
            <img
              alt=""
              style={{ width: "100%", borderRadius: "15px" }}
              src={carrusel3}
            ></img>
          </li>
          <li class="highway-car">
            <img
              alt=""
              style={{ width: "100%", borderRadius: "15px" }}
              src={carrusel4}
            ></img>
          </li>
          <li class="highway-car">
            <img
              alt=""
              style={{ width: "100%", borderRadius: "15px" }}
              src={carrusel5}
            ></img>
          </li>
          <li class="highway-car">
            <img
              alt=""
              style={{ width: "100%", borderRadius: "15px" }}
              src={carrusel6}
            ></img>
          </li>
          <li class="highway-car">
            <img
              alt=""
              style={{ width: "100%", borderRadius: "15px" }}
              src={carrusel7}
            ></img>
          </li>
          <li class="highway-car">
            <img
              alt=""
              style={{ width: "100%", borderRadius: "15px" }}
              src={carrusel8}
            ></img>
          </li>

          <li class="highway-car">
            <img
              alt=""
              style={{ width: "100%", borderRadius: "15px" }}
              src={carrusel1}
            ></img>
          </li>
          <li class="highway-car">
            <img
              alt=""
              style={{ width: "100%", borderRadius: "15px" }}
              src={carrusel2}
            ></img>
          </li>
          <li class="highway-car">
            <img
              alt=""
              style={{ width: "100%", borderRadius: "15px" }}
              src={carrusel3}
            ></img>
          </li>
          <li class="highway-car">
            <img
              alt=""
              style={{ width: "100%", borderRadius: "15px" }}
              src={carrusel4}
            ></img>
          </li>
          <li class="highway-car">
            <img
              alt=""
              style={{ width: "100%", borderRadius: "15px" }}
              src={carrusel5}
            ></img>
          </li>
          <li class="highway-car">
            <img
              alt=""
              style={{ width: "100%", borderRadius: "15px" }}
              src={carrusel6}
            ></img>
          </li>
          <li class="highway-car">
            <img
              alt=""
              style={{ width: "100%", borderRadius: "15px" }}
              src={carrusel7}
            ></img>
          </li>
          <li class="highway-car">
            <img
              alt=""
              style={{ width: "100%", borderRadius: "15px" }}
              src={carrusel8}
            ></img>
          </li> */}
        </ul>
      </div>
    </div>
  );
};

export default InfiniteCarrusel;
